// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UnfavoriteIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UnfavoriteIcon" ref={forwardedRef} {...props}>
      <path d="M7.533 7.486 1.5 8.116 6 12l-1.268 6L10 15.001 15.274 18 14 12l4.5-3.883-6.021-.63L10 2z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UnfavoriteIcon = /* @__PURE__ */ Object.assign(
  UnfavoriteIconComponent,
  { displayName: 'UnfavoriteIcon' },
);
